import { render } from "./SearchNotarialCaseComponent.vue?vue&type=template&id=8292e38a&scoped=true"
import script from "./SearchNotarialCaseComponent.vue?vue&type=script&lang=js"
export * from "./SearchNotarialCaseComponent.vue?vue&type=script&lang=js"

import "./SearchNotarialCaseComponent.vue?vue&type=style&index=0&id=8292e38a&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8292e38a"]])

export default __exports__